import { useEffect, useState } from 'react'
import { Button, Label } from 'reactstrap'
import './TableFilter.css'

const formatText = (txt) => txt.replace("_", " ")

const DateFromTo = ({dateFields, onClick, btnLabel}) => {
    const [dates, setDates] = useState({})

    useEffect(() => {
        dateFields.map(f => {
            if(f.initial) {
                setDates(prev => ({...prev, [f.key]: f.initial}))
            }
        })
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()
        onClick(dates)
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className='mb-4 d-flex align-items-center flex-wrap table-filter'>
                {dateFields && dateFields.map((item, idx) => (
                    <div className="d-flex align-items-center mb-2 me-4" key={idx}>
                        <Label className="mb-0 me-2 text-nowrap">
                            {item.label ? item.label : formatText(item.key)}
                        </Label>
                        <input
                            type="date"
                            onChange={(e) => setDates(f => ({...f, [item.key]: e.target.value}))}
                            placeholder={`Enter date`}
                            className="form-control"
                            required={item.required}
                            value={dates[item.key]}
                            />
                    </div>
                ))}
                <div className='mb-2'>
                    <Button type='submit' color="dark" style={{opacity: '.9'}} >{btnLabel ? btnLabel : "Search"}</Button>
                </div>
            </div>
        </form>
    )
}

export default DateFromTo